import { client } from './client';

// --- Push Subscriptions ---

export const getPushVapidKey = async () => {
    const response = await client.get('/v1/push-subscriptions/vapid-public-key');
    return response.data;
};

export const storePushSubscription = async (subscription) => {
    await client.post('/v1/push-subscriptions', subscription);
};

export const deletePushSubscription = async (endpoint) => {
    await client.delete('/v1/push-subscriptions', { data: { endpoint } });
};
